import { render, staticRenderFns } from "./board_form.vue?vue&type=template&id=53899ec5&"
import script from "./board_form.vue?vue&type=script&lang=js&"
export * from "./board_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "board_form.vue"
export default component.exports